// src/components/ToastContainer.js
import React from 'react';
import { createPortal } from 'react-dom';
import { useNotifications } from '../contexts/NotificationContext';
import ToastNotification from './ToastNotification';

const ToastContainer = () => {
  const { notifications, clearAll } = useNotifications();

  if (notifications.length === 0) return null;

  return createPortal(
    <div className="fixed top-4 right-4 z-50 space-y-2 max-w-sm w-full pointer-events-none">
      <div className="space-y-2 pointer-events-auto">
        {notifications.map((notification) => (
          <ToastNotification
            key={notification.id}
            notification={notification}
          />
        ))}
      </div>
      
      {/* Clear All button when there are multiple notifications */}
      {notifications.length > 2 && (
        <div className="mt-3 flex justify-end pointer-events-auto">
          <button
            onClick={clearAll}
            className="text-xs px-3 py-1 bg-gray-600 text-white rounded-full hover:bg-gray-700 transition-colors"
          >
            Clear All
          </button>
        </div>
      )}
    </div>,
    document.body
  );
};

export default ToastContainer;